import { render, staticRenderFns } from "./choiceFood.vue?vue&type=template&id=feee4f36&scoped=true"
import script from "./choiceFood.vue?vue&type=script&lang=js"
export * from "./choiceFood.vue?vue&type=script&lang=js"
import style0 from "./choiceFood.vue?vue&type=style&index=0&id=feee4f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feee4f36",
  null
  
)

export default component.exports